module.exports = __webpack_public_path__ + "static/media/knight.28b420c9.gif";